exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-unit-icon{color:#5cb85c}.add-unit-caret{height:22px;padding-left:0px !important}.clickable-icon:hover{color:#ffa92e !important}.admin-units-icons{display:flex;justify-content:flex-end;align-items:center;min-width:7rem}.admin-units-icons>i{color:white !important;margin-right:3px}.admin-units-colum-name{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:1px;tooltip-max-width:fit-content}.tooltip-inner{min-width:fit-content}\n", ""]);

// exports
